/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/naming-convention */
import createTypography from '@mui/material/styles/createTypography';
import React from 'react';
import palette from './palette';

function pxToRem(value) {
	return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
	return {
		'@media (max-width:600px)': {
			fontSize: pxToRem(sm),
		},
		'@media (min-width:900px)': {
			fontSize: pxToRem(md),
		},
		'@media (min-width:1200px)': {
			fontSize: pxToRem(lg),
		},
	};
}

const FONT_PRIMARY = 'RubikRegular, Public Sans, sans-serif';

/*type typo = {
    lineHeight: number;
    fontSize: any;
    fontWeight?:number;
}*/

declare module '@mui/material/styles/createTypography' {
	interface CustomTypography {
		body3: React.CSSProperties;
		body4: React.CSSProperties;
		body5: React.CSSProperties;
		boldBody1: React.CSSProperties;
		boldBody2: React.CSSProperties;
		boldBody3: React.CSSProperties;
		boldBody4: React.CSSProperties;
		boldBody5: React.CSSProperties;
		boldBody6: React.CSSProperties;
		boldBody7: React.CSSProperties;
		boldBody17: React.CSSProperties;
		boldBody18: React.CSSProperties;
		semiCaption: React.CSSProperties;
		captionRegular: React.CSSProperties;
		semiCaptionRegular: React.CSSProperties;
		boldMedium: React.CSSProperties;
		lightSmall: React.CSSProperties;
		boldExtraLarge: React.CSSProperties;
		boldSmall: React.CSSProperties;
		boldStat: React.CSSProperties;
		alertBody: React.CSSProperties;
		pageTitle: React.CSSProperties;
		body: React.CSSProperties;
		subtitle: React.CSSProperties;
		subtitleBold: React.CSSProperties;
	}

	interface Typography extends CustomTypography {}
	interface TypographyOptions extends CustomTypography {}
}

export const typography = createTypography(palette, {
	fontFamily: FONT_PRIMARY,
	fontWeightRegular: 400,
	fontWeightMedium: 600,
	fontWeightBold: 700,
	pageTitle: {
		lineHeight: '28px',
		fontSize: pxToRem(24),
		fontWeight: 600,
		...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
	},
	body: {
		lineHeight: '17px',
		fontSize: pxToRem(14),
		fontWeight: 400,
	},
	h4: {
		lineHeight: '24px',
		fontSize: pxToRem(20),
		...responsiveFontSizes({ sm: 16, md: 18, lg: 20 }),
	},
	h5: {
		fontFamily: 'RubikMedium',
		lineHeight: 1.5,
		fontSize: pxToRem(18),
		...responsiveFontSizes({ sm: 14, md: 16, lg: 18 }),
	},
	h6: {
		lineHeight: 28 / 18,
		fontSize: pxToRem(17),
		fontFamily: 'RubikLight',
		...responsiveFontSizes({ sm: 16, md: 17, lg: 17 }),
	},
	subtitle: {
		lineHeight: 1.5,
		fontSize: pxToRem(16),
	},
	subtitleBold: {
		lineHeight: 1.5,
		fontSize: pxToRem(16),
		fontWeight: 700,
	},
	subtitle2: {
		lineHeight: 1.5,
		fontSize: pxToRem(16),
		fontFamily: 'RubikLight',
	},
	body1: {
		lineHeight: 1.5,
		fontSize: pxToRem(14),
		...responsiveFontSizes({ sm: 13, md: 13, lg: 14 }),
	},
	body2: {
		lineHeight: 22 / 14,
		fontSize: pxToRem(14),
	},
	body3: {
		lineHeight: 22 / 15,
		fontSize: pxToRem(15),
		fontFamily: 'RubikLight',
	},
	body4: {
		lineHeight: 1,
		fontSize: pxToRem(15),
		fontFamily: 'RubikRegular',
	},
	body5: {
		lineHeight: '15px',
		fontSize: pxToRem(13),
		fontFamily: 'RubikRegular',
		fontWeight: 400,
	},
	boldBody1: {
		lineHeight: 1.5,
		fontSize: pxToRem(14),
		fontFamily: 'RubikMedium',
	},
	boldBody17: {
		lineHeight: 22 / 17,
		fontSize: pxToRem(17),
		...responsiveFontSizes({ sm: 16, md: 17, lg: 17 }),
		fontFamily: 'RubikMedium',
	},
	boldBody18: {
		letterSpacing: '0.005em',
		lineHeight: 1.5,
		fontSize: pxToRem(15),
		...responsiveFontSizes({ sm: 15, md: 15, lg: 15 }),
		fontFamily: 'RubikMedium',
	},
	boldBody2: {
		lineHeight: 22 / 14,
		fontSize: pxToRem(14),
		fontFamily: 'PloniBold',
	},
	boldBody3: {
		lineHeight: 22 / 14,
		fontSize: pxToRem(32),
		fontFamily: 'PloniBold',
	},
	boldBody4: {
		lineHeight: '16px',
		fontSize: pxToRem(14),
		fontFamily: 'PloniRegular',
	},

	boldBody5: {
		lineHeight: 22 / 14,
		fontSize: pxToRem(18),
		fontFamily: 'PloniBold',
	},
	boldBody6: {
		lineHeight: '16px',
		fontSize: pxToRem(22),
		fontFamily: 'PloniRegular',
	},
	boldBody7: {
		lineHeight: '17px',
		fontSize: pxToRem(14),
		fontFamily: 'PloniRegular',
		fontWeight: '600'
	},
	alertBody: {
		lineHeight: 22 / 14,
		fontSize: pxToRem(14),
		fontFamily: 'RubikRegular',
	},
	caption: {
		lineHeight: 1.5,
		fontSize: pxToRem(12),
		fontFamily: 'RubikMedium',
	},
	captionRegular: {
		lineHeight: 1.5,
		fontSize: pxToRem(12),
	},
	semiCaption: {
		lineHeight: 1.5,
		fontSize: pxToRem(11),
		fontFamily: 'RubikSemiBold',
	},
	semiCaptionRegular: {
		lineHeight: 1,
		fontSize: pxToRem(11),
	},
	overline: {
		fontWeight: 700,
		lineHeight: 1.5,
		fontSize: pxToRem(12),
		letterSpacing: 1.1,
		textTransform: 'uppercase',
	},
	button: {
		fontWeight: 700,
		lineHeight: 24 / 14,
		fontSize: pxToRem(14),
		textTransform: 'capitalize',
	},
	boldMedium: {
		fontSize: pxToRem(15),
		fontFamily: 'RubikMedium',
		fontWeight: 500,
	},
	boldSmall: {
		fontSize: pxToRem(12),
		fontFamily: 'RubikMedium',
		fontWeight: 500,
	},
	boldStat: {
		fontSize: pxToRem(14),
		lineHeight: 1.4,
		fontFamily: 'RubikSemiBold',
	},
	lightSmall: {
		fontSize: pxToRem(12),
		fontWeight: 'normal',
	},
	boldExtraLarge: {
		fontSize: pxToRem(30),
		lineHeight: '36px',
		fontFamily: 'RubikSemiBold',
	},
});
